let quiz = {
    el: {
        choosenOption: '',
        qId: 0,
        isValid: false,
        validOption: '',
        wrongCount: 0,
        rightCount: 0,
    },
    init() {
        if (jQuery("#vspl__quiz").length > 0) {
            let options = jQuery("#vspl__quiz--options").data("options");
            jQuery(document).on("click", "[data-option]", function () {
                quiz.el.choosenOption = jQuery(this).data("option");
                quiz.el.qId = parseInt(jQuery(this).data("qid"));
                quiz.el.isValid = false;
                quiz.el.validOption = options[quiz.el.qId];

                jQuery(this).parent('[data-elements="options"]').addClass('active');

                if (options[quiz.el.qId] == quiz.el.choosenOption) {
                    jQuery(this).addClass("right");
                    quiz.el.isValid = true;
                    quiz.el.rightCount = parseInt(quiz.el.rightCount + 1);
                } else {
                    jQuery(this).addClass("wrong");
                    quiz.el.isValid = false;
                    quiz.el.wrongCount = parseInt(quiz.el.wrongCount + 1);
                }

                if (quiz.el.isValid == false) {
                    setTimeout(() => {
                        jQuery(`[data-question="${quiz.el.qId}"] [data-option="${quiz.el.validOption}"]`).addClass("right");
                    }, 1000);
                }
                setTimeout(() => {
                    jQuery(".vspl__quiz--item.active .vspl__quiz--info").addClass("active");
                }, 1000);


            });

            jQuery(document).on('click', '[data-element="quizbtn"]', function () {
                var qqId = jQuery(this).data("qid");
                jQuery(`.vspl__quiz--item`).removeClass('active');
                jQuery(`.vspl__quiz--item[data-question="${qqId}"]`).addClass('active');

                if (qqId == 11) {
                    jQuery('[data-element="correct"]').html(quiz.el.rightCount);
                    jQuery('[data-element="incorrect"]').html(quiz.el.wrongCount);
                }

            });
        }
    },
};
